export default __webpack_public_path__ + "static/media/impac_StandZona1.ca56c08b.png";